import { CollapseSidePanelButton, ExpandSidePanelButton } from "./SidePanelExpandCollapseButtons"
import { SidePanelCreateButton } from "./SidePanelCreateButton"

export function SidePanelOpenHeader() {
    return (
        <div className="flex flex-col gap-2 px-3 pb-2">
            <div className="flex justify-between relative">
                <SidePanelCreateButton />
                <CollapseSidePanelButton />
            </div>
        </div>
    )
}

export function SidePanelClosedHeader() {
    return (
        <div className="flex flex-col gap-2 px-3 pb-2">
            <div className="flex justify-between relative">
                <SidePanelCreateButton />
                <ExpandSidePanelButton />
            </div>
        </div>
    )
}
